export const defaultCreditTypes = [
  'credit_adjusted',
  'credit_expired',
  'credit_payout',
  'credit_refunded',
  'credit_success_referral',
  'credit_used',
];
